export const MR = {
  nav_home: "मुख्यपृष्ठ", nav_about: "परिचय", nav_treatments: "उपचार", nav_guides: "मार्गदर्शिका",
  nav_contact: "संपर्क", nav_book: "अपॉइंटमेंट बुक करा",
  brand_tag: "ऑर्थोपेडिक साधे व जटिल ट्रॉमा आणि पुनर्बांधणी",
  footer_blurb: "ऑर्थोपेडिक साधी व जटिल ट्रॉमा आणि पुनर्बांधणी सर्जरी तज्ज्ञ — मुंबईत अचूक, पुरावा-आधारित फ्रॅक्चर व सांधे उपचारांद्वारे चालणे पुनर्स्थापित करणे आणि आयुष्य पुन्हा घडवणे.",
  footer_explore: "पहा", footer_reach: "क्लिनिकशी संपर्क साधा",
  footer_rights: "© 2026 डॉ. लोकेश नाइक जी — ऑर्थोपेडिक ट्रॉमा केअर. सर्व हक्क राखीव.",
  footer_opd: "OPD: सोम–शुक्र सकाळी 11 – संध्या. 7 · शनि सकाळी 11 – दु. 3 · रविवार बंद",
  fl_home: "मुख्यपृष्ठ", fl_about: "डॉक्टरांबद्दल", fl_treatments: "उपचार व विशेषज्ञता",
  fl_guides: "रुग्ण मार्गदर्शिका", fl_book: "अपॉइंटमेंट बुक करा", fl_contact: "संपर्क",

  hero_eyebrow: "ऑर्थोपेडिक साधी व जटिल ट्रॉमा सर्जरी · मुंबई",
  hero_line1: "ऑर्थोपेडिक ट्रॉमा व", hero_line2: "सांधा प्रतिस्थापन सल्लागार",
  hero_motto: "\"आयुष्य म्हणजे हालचाल आणि हालचाल म्हणजे आयुष्य\"",
  hero_tagline: "हालचाल पुनर्स्थापित करणे आणि आयुष्य पुन्हा घडवणे…!",
  hero_sub: "{name} — {hospital} येथे {role}. जटिल फ्रॅक्चर, पेल्विक व अ‍ॅसिटाब्युलर ट्रॉमामध्ये विशेषज्ञता — आणि तुम्हाला पुन्हा पायावर उभे करणे.",
  hero_call: "कॉल करा {phone}",
  stat_exp_label: "शस्त्रक्रिया अनुभव",
  strip_from: "शस्त्रक्रिया कक्षातून",
  strip_note: "डॉ. लोकेश नाइक जी यांनी उपचार केलेले खरे केस — रुग्णांचा तपशील गोपनीय",

  phil_eyebrow: "आमची कार्यपद्धती",
  phil_title1: "ट्रॉमा म्हणजे गोंधळ.", phil_title2: "रिकव्हरी म्हणजे कारागिरी.",
  phil1_t: "गोंधळातही अचूकता",
  phil1_b: "फ्रॅक्चर म्हणजे फक्त मोडलेले हाड नव्हे — ते थांबलेले आयुष्य असते. प्रत्येक शस्त्रक्रियेचे नियोजन शरीररचना अगदी अचूक पुनर्स्थापित करण्यासाठी केले जाते, अंदाजाने नव्हे.",
  phil2_t: "मतापूर्वी पुरावा",
  phil2_b: "AO INFINITY अभ्यासापासून आंतरराष्ट्रीय जर्नलच्या संपादकीय मंडळापर्यंत — प्रत्येक उपचार संशोधनावर आधारित आहे, सवयीवर नव्हे.",
  phil3_t: "पुन्हा पायावर",
  phil3_b: "शस्त्रक्रिया म्हणजे केवळ अर्धा प्रवास. प्रत्येक योजनेत पुनर्वसन अंतर्भूत असते — कारण खरा निकाल म्हणजे तुम्ही: चालत, काम करत, जगत.",

  exp_eyebrow: "विशेषज्ञतेचे क्षेत्र",
  exp_title1: "जटिल ट्रॉमा,", exp_title2: "पूर्ण शांततेने.",
  exp_view_all: "सर्व उपचार पहा",

  about_eyebrow: "तुमच्या सर्जनला भेटा",
  about_para: "KIMS हुबली आणि डॉ. बालाभाई नानावटी रुग्णालयात प्रशिक्षित, मुंबई व सियोल येथून ट्रॉमा व आर्थ्रोप्लास्टी फेलोशिप — डॉ. नाइक यांनी त्यांचा कारकीर्द ऑर्थोपेडिक्समधील सर्वात कठीण दुखापतींना समर्पित केली आहे: जटिल फ्रॅक्चर, पेल्विक ट्रॉमा, नॉनयुनियन आणि ट्रॉमा-नंतरच्या विकृती.",
  about_badge1: "AO INFINITY अभ्यास सह-संशोधक",
  about_badge2: "जर्नल संपादक व समीक्षक",
  about_badge3: "ट्रॉमा व सांधा प्रतिस्थापन",
  about_link: "संपूर्ण कथा वाचा",

  hosp_eyebrow: "आम्हाला कुठे भेटाल",
  hosp_para: "भारतातील सर्वात प्रगत क्वाटर्नरी केअर केंद्रांपैकी एक — समर्पित ट्रॉमा टीम, अत्याधुनिक ऑपरेशन थिएटर आणि चोवीस तास आपत्कालीन सेवा. डॉ. नाइक येथे ट्रॉमा व जटिल फ्रॅक्चर सेवांचे नेतृत्व करतात.",
  hosp_cta: "भेटीचे नियोजन करा",

  stories_eyebrow: "रुग्णांचे अनुभव",
  stories_verified: "{count} सत्यापित Google पुनरावलोकने",
  overlay_quote: "\"पुन्हा आयुष्याकडे.\"", overlay_sub: "एकमेव महत्त्वाचा निकाल",
  wall_title1: "प्रत्येक रिकव्हरीमागे", wall_title2: "एक कथा असते.",
  wall_link: "Google वर सर्व {count} पुनरावलोकने वाचा",
  google_tag: "Google",

  cta_eyebrow: "तुमची रिकव्हरी सुरू करा",
  cta_title1: "तुमची रिकव्हरी सुरू होते", cta_title2: "एका संवादाने.",

  mq1: "अचूकता", mq2: "पुनर्स्थापना", mq3: "गतिमानता", mq4: "विश्वास",
  mq5: "पुरावा-आधारित काळजी", mq6: "रिकव्हरी",

  ab_hero_eyebrow: "डॉक्टरांबद्दल",
  ab_hero_l1: "सर्वात कठीण फ्रॅक्चरवर", ab_hero_l2: "घडवलेली कारकीर्द.",
  ab_hero_sub: "दावणगेरेच्या वर्गखोल्यांपासून मुंबईच्या ऑपरेशन थिएटर आणि सियोलच्या फेलोशिप हॉलपर्यंत — एकाच आश्वासनासाठी समर्पित उत्कृष्टतेचा प्रवास: हालचाल पुनर्स्थापित करणे, आणि तिच्यासोबत आयुष्यही.",
  ab_qual_eyebrow: "पात्रता",
  ab_qual_title1: "प्रशिक्षण:", ab_qual_title2: "भारत व दक्षिण कोरिया.",
  ab_bio1: "लोकेश नाइक जी यांनी त्यांचे वैद्यकीय शिक्षण JJMMC दावणगेरे येथे सुरू केले, जेथे मानवी शरीराच्या कार्यपद्धतीची आवड रुजली. KIMS हुबली येथे शस्त्रक्रिया पाया मजबूत केला आणि प्रसिद्ध डॉ. बालाभाई नानावटी रुग्णालय, मुंबई येथून ऑर्थोपेडिक सर्जरीमध्ये D.N.B. मिळवली — देशातील सर्वात कठीण प्रशिक्षण केंद्रांपैकी एक.",
  ab_bio2: "इतर सर्जन हात घालायला घाबरतात अशा दुखापती मिळवण्यासाठी त्यांनी मुंबईत ट्रॉमा व आर्थ्रोप्लास्टीची प्रगत फेलोशिप केली, नंतर सांधा प्रतिस्थापनाची जागतिक राजधानी सियोल, दक्षिण कोरिया येथे गेले — रिव्हिजन आर्थ्रोप्लास्टी फेलोशिपसाठी: अयशस्वी शस्त्रक्रियांना दुसरे आयुष्य देण्याची सूक्ष्म विद्या.",
  ab_bio3: "आज प्रत्येक सल्लामसलतीत त्या प्रवासाचा सार आहे — जागतिक दर्जाचे प्रशिक्षण, अशा प्रेमाने दिले जाते जे सर्वात घाबरलेल्या रुग्णालाही निवांत करते. ऑपरेशन थिएटरच्या पलिकडेही त्यांनी राष्ट्रीय व आंतरराष्ट्रीय जर्नलमध्ये संशोधन प्रकाशित केले आहे आणि पुस्तकांचे प्रकरणे लिहिली आहेत.",
  ab_journey_eyebrow: "प्रवास", ab_journey_title: "उत्कृष्टतेचा एक प्रवास.",
  ab_research_eyebrow: "संशोधन व शैक्षणिक",
  ab_research_title1: "सर्जन जो", ab_research_title2: "विज्ञानही लिहितो.",
  ab_infinity_label: "ऐतिहासिक संशोधन",
  ab_infinity_title: "'INFINITY' अभ्यास — AO फाउंडेशन, दावोस",
  ab_infinity_body: "डॉ. नाइक फ्रॅक्चर फिक्सेशनमधील संसर्गावरील जगातील सर्वात मोठ्या बहु-केंद्रीय अभ्यासाचे (2013–2015) सह-संशोधक होते — असे संशोधन जे जगभरातील सर्जन या गंभीर गुंतागुंत वा टाळण्याची वा उपचाराची पद्धत घडवतात.",
  ab_editorial_label: "संपादकीय व समीक्षा भूमिका",
  ab_cta_title1: "अनुभव जो प्रत्येक", ab_cta_title2: "निकालात दिसतो.",

  tl1_p: "सुरुवात", tl2_p: "5 वर्षे", tl3_p: "रेझिडन्सी", tl4_p: "2 वर्षे",
  tl5_p: "2013 — 2015", tl6_p: "फेलोशिप", tl7_p: "2016 – सध्याचे",
  tl1_r: "M.B.B.S., नंतर ऑर्थोपेडिक्समध्ये डिप्लोमा",
  tl2_r: "ऑर्थोपेडिक सर्जरीमध्ये लेक्चरर / सल्लागार",
  tl3_r: "D.N.B. (ऑर्थोपेडिक सर्जरी)",
  tl4_r: "क्लिनिकल असोसिएट, ऑर्थोपेडिक्स",
  tl5_r: "सह-संशोधक, 'INFINITY' अभ्यास",
  tl6_r: "ट्रॉमा व प्रायमरी आर्थ्रोप्लास्टी (मुंबई), रिव्हिजन आर्थ्रोप्लास्टी (सियोल)",
  tl7_r: "वरिष्ठ ऑर्थोपेडिक ट्रॉमा, पुनर्बांधणी व सांधा प्रतिस्थापन सल्लागार",

  tr_hero_eyebrow: "उपचार व विशेषज्ञता",
  tr_hero_l1: "आठ क्षेत्रे.", tr_hero_l2: "एकच निकष: अचूकता.",
  tr_hero_sub: "ऑर्थोपेडिक ट्रॉमा क्षमा करत नाही — पहिला उपचार बहुधा रुग्णाचे उरलेले आयुष्य ठरवतो. सर एच. एन. रिलायन्स फाउंडेशन रुग्णालय, मुंबई येथे डॉ. नाइक रोज ज्या आजारांचा उपचार करतात त्या या आहेत.",
  tr_guide_link: "रुग्ण मार्गदर्शिका वाचा",
  tr_proc_eyebrow: "केल्या जाणाऱ्या शस्त्रक्रिया",
  tr_proc_title1: "शस्त्रक्रिया कौशल्य,", tr_proc_title2: "सुरुवातीपासून शेवटपर्यंत.",
  tr_proc_quote: "\"पुनर्स्थापना म्हणजे विज्ञानाने केलेली कला.\"",
  tr_cta_title1: "कोणता उपचार तुमच्या", tr_cta_title2: "स्थितीसाठी योग्य हे ठळक नाही?",
  tr_cta_sub: "तुमच्या अहवाल आणि एक्स-रे सोबत आणा. बहुधा एकच सल्लामसलत पुढचा मार्ग ठरवण्यासाठी पुरेशी असते.",
  tr_cta_btn: "सल्लामसलत बुक करा",

  pr1: "ओपन रिडक्शन व इंटरनल फिक्सेशन (ORIF)",
  pr2: "टोटल हिप रिप्लेसमेंट",
  pr3: "टोटल नी रिप्लेसमेंट",
  pr4: "रिव्हिजन व रीडू ऑर्थोपेडिक शस्त्रक्रिया",
  pr5: "अवयव लांबी वाढ व विकृती दुरुस्ती",
  pr6: "अँकल फ्यूजन शस्त्रक्रिया",
  pr7: "वाकड्या पायांची (बो लेग्स) दुरुस्ती",
  pr8: "फ्रॅक्चर फिक्सेशन — साध्यापासून जटिलापर्यंत",

  bk_hero_eyebrow: "अपॉइंटमेंट बुक करा",
  bk_hero_l1: "चला तुमची रिकव्हरी", bk_hero_l2: "एकत्र घडवूया.",
  bk_hero_sub: "काही माहिती शेअर करा — क्लिनिक {name} यांच्यासोबत तुमच्या सल्लामसलतीची पुष्टी करेल. तातडीच्या ट्रॉमासाठी थेट कॉल करा.",
  bk_info_eyebrow: "बोलायला अवडेल?",
  bk_call_label: "कॉल / WhatsApp", bk_email_label: "ईमेल", bk_clinic_label: "क्लिनिक",
  bk_opd_label: "OPD वेळा", bk_opd1: "सोम – शुक्र: सकाळी 11 – संध्या. 7", bk_opd2: "शनि: सकाळी 11 – दु. 3 · रवि: बंद",
  bk_em_label: "ट्रॉमा आपत्काल?",
  bk_em_body: "ऑनलाइन पुष्टीची वाट पाहू नका. लगेच {phone} वर कॉल करा किंवा आपत्कालीन विभागात जा.",
  f_name: "पूर्ण नाव *", f_age: "वय *", f_sex: "लिंग *", f_phone: "फोन *", f_email: "ईमेल *",
  f_date: "पसंतीची तारीख *", f_time: "पसंतीची वेळ *", f_concern: "तक्रार *", f_message: "अजून सांगा (ऐच्छिक)",
  f_name_ph: "तुमचे पूर्ण नाव", f_age_ph: "वर्षे", f_phone_ph: "+91 ...", f_email_ph: "you@example.com",
  f_time_ph: "वेळ निवडा", f_concern_ph: "कोणत्या तक्रारीसाठी आला?", f_sex_ph: "निवडा",
  f_message_ph: "तुमची दुखापत किंवा तक्रार थोडक्यात सांगा, आणि काही अहवाल किंवा एक्स-रे असल्यास नमूद करा.",
  f_submit: "अपॉइंटमेंटची विनंती करा", f_submitting: "पाठवत आहे…",
  f_note: "तुमची विनंती थेट डॉक्टरांच्या कार्यालयाला {email} वर ईमेल होते. ऑनलाइन कोणतेही शुल्क घेतले जात नाही.",
  f_validation: "कृपया रुग्णाचे लिंग, तक्रार आणि पसंतीची वेळ निवडा.",
  sex_m: "पुरुष", sex_f: "स्त्री", sex_o: "इतर",
  c1: "फ्रॅक्चर / ट्रॉमा", c2: "सांधा प्रतिस्थापन", c3: "नॉनयुनियन / मालयुनियन",
  c4: "हाड किंवा सांध्याचा संसर्ग", c5: "विकृती दुरुस्ती", c6: "दुसरे मत", c7: "इतर",
  ts1: "सकाळ (10 – दु. 1)", ts2: "दुपार (2 – संध्या. 5)", ts3: "संध्याकाळ (5 – रात्री 8)",
  ok_title: "विनंती मिळाली.",
  ok_body: "धन्यवाद, {name}. {date} ({slot}) साठी तुमची अपॉइंटमेंट विनंती क्लिनिकला पाठवली आहे. पुष्टीकरणासाठी क्लिनिक तुम्हाला {phone} वर कॉल करेल.",
  ok_ref: "संदर्भ:", ok_another: "आणखी एक अपॉइंटमेंट बुक करा",
  ok_email_note: " आणि डॉक्टरांच्या कार्यालयाला ईमेलही झाला आहे.",
  toast_success: "अपॉइंटमेंट विनंती पाठवली. क्लिनिक लवकरच पुष्टी करेल.",
  toast_error: "आत्ता सबमिट झाले नाही — कृपया क्लिनिकला थेट कॉल करा.",

  ct_hero_eyebrow: "संपर्क",
  ct_hero_l1: "एक कॉल बदलू शकते", ct_hero_l2: "तुमच्या चालण्याची दिशा.",
  ct_hero_sub: "ताजी दुखापत असो, न भरलेला फ्रॅक्टर असो, वा दुसरे मत — संपर्क साधा. प्रत्येक चौकशीचे उत्तर क्लिनिक स्वतः देते.",
  ct_call_label: "कॉल किंवा WhatsApp",
  ct_call_body: "क्लिनिकशी संपर्काचा सर्वात जलद मार्ग — अपॉइंटमेंट व तातडीच्या ट्रॉमा चौकशींसाठी.",
  ct_call_now: "आत्ताच कॉल करा",
  ct_email_label: "आम्हाला लिहा",
  ct_email_body: "अहवाल, एक्स-रे किंवा प्रश्न शेअर करा. ऑनलाइन पाठवलेल्या बुकिंग विनंत्या ही इथेच येतात.",
  ct_email_cta: "ईमेल पाठवा",
  ct_visit_label: "क्लिनिकला भेट द्या", ct_hours_label: "सल्लामसलत वेळा",
  ct_em: "ट्रॉमा आपत्कालात {phone} वर कॉल करा — कोणत्याही वेळी.",
  ct_strip_label: "रांग टाळा",
  ct_strip_title: "एक मिनिटाहून कमी वेळेत ऑनलाइन अपॉइंटमेंट बुक करा.",
  ct_strip_btn: "आत्ताच बुक करा",
  ct_map_label: "नकाशावर आम्हाला शोधा", ct_directions: "मार्ग पहा",
  ct_linkedin: "LinkedIn वर डॉ. लोकेश नाइक जी",
  opd_mf: "सोमवार – शुक्रवार", opd_sat: "शनिवार", opd_sun: "रविवार", opd_closed: "बंद",

  cd_hero_eyebrow: "रुग्ण मार्गदर्शिका",
  cd_hero_l1: "तुमची दुखापत समजून घ्या.", cd_hero_l2: "रिकव्हरी स्वतःच्या हातात घ्या.",
  cd_hero_sub: "डॉ. नाइक ज्या आजारांचा उपचार करतात त्यांच्या साध्या भाषेतील मार्गदर्शिका — ते काय आहेत, निदान कसे होते, आणि उपचार व रिकव्हरी प्रत्यक्षात कशी असते.",

  gd_prefix: "रुग्ण मार्गदर्शिका", gd_of: "पैकी",
  sec_overview: "परिचय", sec_overview_q: "हे काय आहे?",
  sec_symptoms: "लक्षणे", sec_symptoms_q: "कसे जाणवते?",
  sec_diagnosis: "निदान", sec_diagnosis_q: "तपासणी कशी होते?",
  sec_treatment: "उपचार", sec_treatment_q: "उपचार कसे होतात?",
  sec_recovery: "रिकव्हरी", sec_recovery_q: "रिकव्हरी कशी असते?",
  gd_urgent_title: "तातडीने दाखल केव्हा व्हावे",
  gd_cta_eyebrow: "तज्ज्ञांशी बोला",
  gd_cta_title: "ही लक्षणे आहेत? स्पष्ट योजना मिळवा.",
  gd_cta_body: "तुमचे एक्स-रे आणि अहवाल सोबत आणा — बहुधा एकच सल्लामसलत पुढचा मार्ग ठरवण्यासाठी पुरेशी असते.",
  gd_cta_book: "सल्लामसलत बुक करा", gd_next: "पुढील मार्गदर्शिका",
  gd_notfound: "मार्गदर्शिका सापडली नाही.", gd_back: "सर्व मार्गदर्शिकांकडे परत",
};

export const GU = {
  nav_home: "હોમ", nav_about: "પરિચય", nav_treatments: "સારવાર", nav_guides: "માર્ગદર્શિકા",
  nav_contact: "સંપર્ક", nav_book: "એપોઈન્ટમેન્ટ બુક કરો",
  brand_tag: "ઓર્થોપેડિક સાધા અને જટિલ ટ્રોમા તથા પુનઃનિર્માણ",
  footer_blurb: "ઓર્થોપેડિક સાધી અને જટિલ ટ્રોમા તથા પુનઃનિર્માણ સર્જરી નિષ્ણાત — મુંબઈમાં ચોક્કસ, પુરાવા-આધારિત ફ્રેક્ચર અને સાંધા સંભાળથી ચાલવાનું પુનઃસ્થાપિત કરવું અને જીવન ફરી ઘડવું.",
  footer_explore: "જુઓ", footer_reach: "ક્લિનિકનો સંપર્ક કરો",
  footer_rights: "© 2026 ડૉ. લોકેશ નાયક જી — ઓર્થોપેડિક ટ્રોમા કેર. સર્વ હક્કો સુરક્ષિત.",
  footer_opd: "OPD: સોમ–શુક્ર સવારે 11 – સાંજે 7 · શનિ સવારે 11 – બપોરે 3 · રવિવાર બંધ",
  fl_home: "હોમ", fl_about: "ડૉક્ટર વિશે", fl_treatments: "સારવાર અને નિષ્ણાતતા",
  fl_guides: "દર્દી માર્ગદર્શિકા", fl_book: "એપોઈન્ટમેન્ટ બુક કરો", fl_contact: "સંપર્ક",

  hero_eyebrow: "ઓર્થોપેડિક સાધી અને જટિલ ટ્રોમા સર્જરી · મુંબઈ",
  hero_line1: "ઓર્થોપેડિક ટ્રોમા અને", hero_line2: "સાંધા રિપ્લેસમેન્ટ સલાહકાર",
  hero_motto: "\"જીવન એટલે હિલચાલ અને હિલચાલ એટલે જીવન\"",
  hero_tagline: "હિલચાલ પુનઃસ્થાપિત કરવી અને જીવન ફરી ઘડવું…!",
  hero_sub: "{name} — {hospital} ખાતે {role}. જટિલ ફ્રેક્ચર, પેલ્વિક અને એસિટેબ્યુલર ટ્રોમામાં નિષ્ણાત — અને તમને ફરી પગ પર ઊભા કરવા.",
  hero_call: "કૉલ કરો {phone}",
  stat_exp_label: "સર્જિકલ અનુભવ",
  strip_from: "શસ્ત્રક્રિયા કક્ષમાંથી",
  strip_note: "ડૉ. લોકેશ નાયક જી દ્વારા સારવાર પામેલા વાસ્તવિક કેસ — દર્દીની વિગતો ગોપનીય",

  phil_eyebrow: "અમારી કાર્યપદ્ધતિ",
  phil_title1: "ટ્રોમા એટલે ગડબડ.", phil_title2: "રિકવરી એટલે કારીગરી.",
  phil1_t: "ગડબડમાં પણ ચોકસાઈ",
  phil1_b: "ફ્રેક્ચર ફક્ત તૂટેલું હાડકું નથી — તે અટકી ગયેલું જીવન છે. દરેક સર્જરીનું આયોજન શરીરરચના સંપૂર્ણ પુનઃસ્થાપિત કરવા માટે થાય છે, અંદાજથી નહીં.",
  phil2_t: "મંતવ્ય પહેલાં પુરાવો",
  phil2_b: "AO INFINITY અભ્યાસથી લઈને આંતરરાષ્ટ્રીય જર્નલના સંપાદકીય મંડળ સુધી — દરેક સારવાર સંશોધન પર આધારિત છે, આદત પર નહીં.",
  phil3_t: "ફરી પગ પર",
  phil3_b: "સર્જરી તો માત્ર અડધો રસ્તો છે. દરેક યોજનામાં પુનર્વસન સામેલ છે — કારણ કે સાચું પરિણામ તમે છો: ચાલતા, કામ કરતા, જીવતા.",

  exp_eyebrow: "નિષ્ણાતતાના ક્ષેત્રો",
  exp_title1: "જટિલ ટ્રોમા,", exp_title2: "સંપૂર્ણ શાંતિથી.",
  exp_view_all: "તમામ સારવાર જુઓ",

  about_eyebrow: "તમારા સર્જનને મળો",
  about_para: "KIMS હુબલી અને ડૉ. બાલાભાઈ નાનાવટી હોસ્પિટલમાં તાલીમબદ્ધ, મુંબઈ અને સિઓલથી ટ્રોમા અને આર્થ્રોપ્લાસ્ટી ફેલોશિપ — ડૉ. નાયકે પોતાની કારકિર્દી ઓર્થોપેડિક્સની સૌથી મુશ્કેલ ઈજાઓને સમર્પિત કરી છે: જટિલ ફ્રેક્ચર, પેલ્વિક ટ્રોમા, નોનયુનિયન અને ટ્રોમા પછીની વિકૃતિઓ.",
  about_badge1: "AO INFINITY અભ્યાસ સહ-સંશોધક",
  about_badge2: "જર્નલ સંપાદક અને સમીક્ષક",
  about_badge3: "ટ્રોમા અને સાંધા રિપ્લેસમેન્ટ",
  about_link: "સંપૂર્ણ વાર્તા વાંચો",

  hosp_eyebrow: "અમને ક્યાં મળશો",
  hosp_para: "ભારતના સૌથી અદ્યતન ક્વાટરનરી કેર કેન્દ્રોમાંનું એક — સમર્પિત ટ્રોમા ટીમ, અત્યાધુનિક ઓપરેશન થિયેટર અને ચોવીસ કલાક કટોકટી સેવા. ડૉ. નાયક અહીં ટ્રોમા અને જટિલ ફ્રેક્ચર સેવાઓનું નેતૃત્વ કરે છે.",
  hosp_cta: "મુલાકાતનું આયોજન કરો",

  stories_eyebrow: "દર્દીઓના અનુભવો",
  stories_verified: "{count} ચકાસાયેલ Google સમીક્ષાઓ",
  overlay_quote: "\"ફરી જીવન તરફ.\"", overlay_sub: "એકમાત્ર મહત્વનું પરિણામ",
  wall_title1: "દરેક રિકવરી પાછળ", wall_title2: "એક વાર્તા છે.",
  wall_link: "Google પર તમામ {count} સમીક્ષાઓ વાંચો",
  google_tag: "Google",

  cta_eyebrow: "તમારી રિકવરી શરૂ કરો",
  cta_title1: "તમારી રિકવરી શરૂ થાય છે", cta_title2: "એક વાતચીતથી.",

  mq1: "ચોકસાઈ", mq2: "પુનઃસ્થાપના", mq3: "ગતિશીલતા", mq4: "વિશ્વાસ",
  mq5: "પુરાવા-આધારિત સંભાળ", mq6: "રિકવરી",

  ab_hero_eyebrow: "ડૉક્ટર વિશે",
  ab_hero_l1: "સૌથી જટિલ ફ્રેક્ચર પર", ab_hero_l2: "ઘડાયેલી કારકિર્દી.",
  ab_hero_sub: "દાવણગેરેના વર્ગખંડોથી મુંબઈના ઓપરેશન થિયેટર અને સિઓલના ફેલોશિપ હોલ સુધી — એક જ વાયદા માટે સમર્પિત શ્રેષ્ઠતાની યાત્રા: હિલચાલ પુનઃસ્થાપિત કરવી, અને તેની સાથે જીવન પણ.",
  ab_qual_eyebrow: "લાયકાત",
  ab_qual_title1: "તાલીમ:", ab_qual_title2: "ભારત અને દક્ષિણ કોરિયા.",
  ab_bio1: "લોકેશ નાયક જીએ JJMMC દાવણગેરેથી તબીબી શિક્ષણ શરૂ કર્યું, જ્યાં માનવ શરીરની કાર્યપદ્ધતિનો શોખ ઊગ્યો. KIMS હુબલીથી સર્જિકલ પાયો મજબૂત કર્યો અને પ્રખ્યાત ડૉ. બાલાભાઈ નાનાવટી હોસ્પિટલ, મુંબઈથી ઓર્થોપેડિક સર્જરીમાં D.N.B. મેળવી — દેશના સૌથી મુશ્કેલ તાલીમ કેન્દ્રોમાંનું એક.",
  ab_bio2: "જે ઈજાઓને સ્પર્શવામાં બીજા સર્જન અચકાય તે પાર પાડવા તેમણે મુંબઈમાં ટ્રોમા અને આર્થ્રોપ્લાસ્ટીની અદ્યતન ફેલોશિપ કરી, પછી સાંધા રિપ્લેસમેન્ટની વૈશ્વિક રાજધાની સિઓલ, દક્ષિણ કોરિયા ગયા — રિવિઝન આર્થ્રોપ્લાસ્ટી ફેલોશિપ માટે: નિષ્ફળ સર્જરીને બીજું જીવન આપવાની સૂક્ષ્મ વિદ્યા.",
  ab_bio3: "આજે દરેક પરામર્શમાં તે યાત્રાનો સાર છે — વર્લ્ડ-ક્લાસ તાલીમ, એવા સ્નેહથી આપવામાં આવે છે જે સૌથી ગભરાયેલા દર્દીને પણ સહજ કરી દે. ઓપરેશન થિયેટરની બહાર પણ તેઓ રાષ્ટ્રીય અને આંતરરાષ્ટ્રીય જર્નલમાં સંશોધન પ્રકાશિત કરી ચૂક્યા છે અને પુસ્તક પ્રકરણો લખ્યા છે.",
  ab_journey_eyebrow: "યાત્રા", ab_journey_title: "શ્રેષ્ઠતાની એક યાત્રા.",
  ab_research_eyebrow: "સંશોધન અને શૈક્ષણિક",
  ab_research_title1: "સર્જન જે", ab_research_title2: "વિજ્ઞાન પણ લખે છે.",
  ab_infinity_label: "ઐતિહાસિક સંશોધન",
  ab_infinity_title: "'INFINITY' અભ્યાસ — AO ફાઉન્ડેશન, દાવોસ",
  ab_infinity_body: "ડૉ. નાયક ફ્રેક્ચર ફિક્સેશનમાં ચેપ પરના વિશ્વના સૌથી મોટા બહુ-કેન્દ્રીય અભ્યાસ (2013–2015) ના સહ-સંશોધક રહ્યા — એવું સંશોધન જે વિશ્વભરના સર્જન આ ગંભીર જટિલતાને રોકવા અને સારવાર કરવાની રીતને આકાર આપે છે.",
  ab_editorial_label: "સંપાદકીય અને સમીક્ષા ભૂમિકાઓ",
  ab_cta_title1: "અનુભવ જે દરેક", ab_cta_title2: "પરિણામમાં દેખાય છે.",

  tl1_p: "શરૂઆત", tl2_p: "5 વર્ષ", tl3_p: "રેઝિડન્સી", tl4_p: "2 વર્ષ",
  tl5_p: "2013 — 2015", tl6_p: "ફેલોશિપ", tl7_p: "2016 – હાલમાં",
  tl1_r: "M.B.B.S., પછી ઓર્થોપેડિક્સમાં ડિપ્લોમા",
  tl2_r: "ઓર્થોપેડિક સર્જરીમાં લેક્ચરર / સલાહકાર",
  tl3_r: "D.N.B. (ઓર્થોપેડિક સર્જરી)",
  tl4_r: "ક્લિનિકલ એસોસિએટ, ઓર્થોપેડિક્સ",
  tl5_r: "સહ-સંશોધક, 'INFINITY' અભ્યાસ",
  tl6_r: "ટ્રોમા અને પ્રાથમિક આર્થ્રોપ્લાસ્ટી (મુંબઈ), રિવિઝન આર્થ્રોપ્લાસ્ટી (સિઓલ)",
  tl7_r: "વરિષ્ઠ ઓર્થોપેડિક ટ્રોમા, પુનઃનિર્માણ અને સાંધા રિપ્લેસમેન્ટ સલાહકાર",

  tr_hero_eyebrow: "સારવાર અને નિષ્ણાતતા",
  tr_hero_l1: "આઠ ક્ષેત્રો.", tr_hero_l2: "એક જ ધોરણ: ચોકસાઈ.",
  tr_hero_sub: "ઓર્થોપેડિક ટ્રોમા માફ કરતું નથી — પ્રથમ સારવાર ઘણીવાર દર્દીનું બાકીનું જીવન નક્કી કરે છે. સર એચ. એન. રિલાયન્સ ફાઉન્ડેશન હોસ્પિટલ, મુંબઈમાં ડૉ. નાયક રોજ જે સ્થિતિઓની સારવાર કરે છે તે આ છે.",
  tr_guide_link: "દર્દી માર્ગદર્શિકા વાંચો",
  tr_proc_eyebrow: "કરવામાં આવતી સર્જરી",
  tr_proc_title1: "સર્જિકલ કુશળતા,", tr_proc_title2: "શરૂઆતથી અંત સુધી.",
  tr_proc_quote: "\"પુનઃસ્થાપના એટલે વિજ્ઞાનથી થતી કળા.\"",
  tr_cta_title1: "ખબર નથી કઈ સારવાર", tr_cta_title2: "તમારી સ્થિતિ માટે યોગ્ય છે?",
  tr_cta_sub: "તમારા રિપોર્ટ અને એક્સ-રે સાથે લાવો. ઘણીવાર એક જ પરામર્શ આગળનો રસ્તો નક્કી કરવા પૂરતો હોય છે.",
  tr_cta_btn: "પરામર્શ બુક કરો",

  pr1: "ઓપન રિડક્શન અને ઇન્ટર્નલ ફિક્સેશન (ORIF)",
  pr2: "ટોટલ હિપ રિપ્લેસમેન્ટ",
  pr3: "ટોટલ ની રિપ્લેસમેન્ટ",
  pr4: "રિવિઝન અને રીડૂ ઓર્થોપેડિક સર્જરી",
  pr5: "અંગ લંબાવવું અને વિકૃતિ સુધારો",
  pr6: "એંકલ ફ્યુઝન સર્જરી",
  pr7: "વાંકા પગ (બો લેગ્સ) નો સુધારો",
  pr8: "ફ્રેક્ચર ફિક્સેશન — સાધું થી જટિલ",

  bk_hero_eyebrow: "એપોઈન્ટમેન્ટ બુક કરો",
  bk_hero_l1: "ચાલો તમારી રિકવરી", bk_hero_l2: "સાથે મળીને ઘડીએ.",
  bk_hero_sub: "થોડી વિગતો શેર કરો — ક્લિનિક {name} સાથે તમારા પરામર્શની પુષ્ટિ કરશે. તાત્કાલિક ટ્રોમા માટે સીધો કૉલ કરો.",
  bk_info_eyebrow: "વાત કરવી ગમશે?",
  bk_call_label: "કૉલ / WhatsApp", bk_email_label: "ઈમેલ", bk_clinic_label: "ક્લિનિક",
  bk_opd_label: "OPD સમય", bk_opd1: "સોમ – શુક્ર: સવારે 11 – સાંજે 7", bk_opd2: "શનિ: સવારે 11 – બપોરે 3 · રવિ: બંધ",
  bk_em_label: "ટ્રોમા કટોકટી?",
  bk_em_body: "ઓનલાઈન પુષ્ટિની રાહ ન જુઓ. તરત {phone} પર કૉલ કરો અથવા કટોકટી વિભાગમાં જાઓ.",
  f_name: "પૂરું નામ *", f_age: "ઉંમર *", f_sex: "લિંગ *", f_phone: "ફોન *", f_email: "ઈમેલ *",
  f_date: "પસંદગીની તારીખ *", f_time: "પસંદગીનો સમય *", f_concern: "તકલીફ *", f_message: "વધુ જણાવો (વૈકલ્પિક)",
  f_name_ph: "તમારું પૂરું નામ", f_age_ph: "વર્ષ", f_phone_ph: "+91 ...", f_email_ph: "you@example.com",
  f_time_ph: "સમય પસંદ કરો", f_concern_ph: "કઈ તકલીફ માટે આવ્યા?", f_sex_ph: "પસંદ કરો",
  f_message_ph: "તમારી ઈજા કે તકલીફ ટૂંકમાં જણાવો, અને કોઈ રિપોર્ટ કે એક્સ-રે હોય તો ઉલ્લેખ કરો.",
  f_submit: "એપોઈન્ટમેન્ટ વિનંતી કરો", f_submitting: "મોકલાઈ રહ્યું છે…",
  f_note: "તમારી વિનંતી સીધી ડૉક્ટરની ઓફિસને {email} પર ઈમેલ થાય છે. ઓનલાઈન કોઈ ચુકવણી લેવામાં આવતી નથી.",
  f_validation: "કૃપા કરી દર્દીનું લિંગ, તકલીફ અને પસંદગીનો સમય પસંદ કરો.",
  sex_m: "પુરુષ", sex_f: "સ્ત્રી", sex_o: "અન્ય",
  c1: "ફ્રેક્ચર / ટ્રોમા", c2: "સાંધા રિપ્લેસમેન્ટ", c3: "નોનયુનિયન / માલયુનિયન",
  c4: "હાડકાં કે સાંધાનો ચેપ", c5: "વિકૃતિ સુધારો", c6: "બીજો અભિપ્રાય", c7: "અન્ય",
  ts1: "સવાર (10 – બપોરે 1)", ts2: "બપોર (2 – સાંજે 5)", ts3: "સાંજ (5 – રાત્રે 8)",
  ok_title: "વિનંતી મળી ગઈ.",
  ok_body: "આભાર, {name}. {date} ({slot}) માટે તમારી એપોઈન્ટમેન્ટ વિનંતી ક્લિનિકને મોકલાઈ ગઈ છે. પુષ્ટિ માટે ક્લિનિક તમને {phone} પર કૉલ કરશે.",
  ok_ref: "સંદર્ભ:", ok_another: "બીજી એપોઈન્ટમેન્ટ બુક કરો",
  ok_email_note: " અને ડૉક્ટરની ઓફિસને ઈમેલ પણ થઈ ગયો છે.",
  toast_success: "એપોઈન્ટમેન્ટ વિનંતી મોકલાઈ. ક્લિનિક ટૂંકમાં પુષ્ટિ કરશે.",
  toast_error: "હમણાં સબમિટ થઈ શક્યું નથી — કૃપા કરી ક્લિનિકને સીધો કૉલ કરો.",

  ct_hero_eyebrow: "સંપર્ક",
  ct_hero_l1: "એક કૉલ બદલી શકે છે", ct_hero_l2: "તમારી ચાલવાની રીત.",
  ct_hero_sub: "તાજી ઈજા હોય, ન ભરાતું ફ્રેક્ચર હોય, કે બીજો અભિપ્રાય — સંપર્ક કરો. દરેક પૂછપરછનો જવાબ ક્લિનિક પોતે આપે છે.",
  ct_call_label: "કૉલ અથવા WhatsApp",
  ct_call_body: "ક્લિનિક સુધી પહોંચવાનો સૌથી ઝડપી રસ્તો — એપોઈન્ટમેન્ટ અને તાત્કાલિક ટ્રોમા પૂછપરછ માટે.",
  ct_call_now: "હમણાં કૉલ કરો",
  ct_email_label: "અમને લખો",
  ct_email_body: "રિપોર્ટ, એક્સ-રે કે પ્રશ્નો શેર કરો. ઓનલાઈન મોકલેલી બુકિંગ વિનંતીઓ પણ અહીંયા આવે છે.",
  ct_email_cta: "ઈમેલ મોકલો",
  ct_visit_label: "ક્લિનિકની મુલાકાત લો", ct_hours_label: "પરામર્શ સમય",
  ct_em: "ટ્રોમા કટોકટીમાં {phone} પર કૉલ કરો — ગમે તે સમયે.",
  ct_strip_label: "કતાર ટાળો",
  ct_strip_title: "એક મિનિટથી પણ ઓછા સમયમાં ઓનલાઈન એપોઈન્ટમેન્ટ બુક કરો.",
  ct_strip_btn: "હમણાં બુક કરો",
  ct_map_label: "નકશા પર અમને શોધો", ct_directions: "રસ્તો જુઓ",
  ct_linkedin: "LinkedIn પર ડૉ. લોકેશ નાયક જી",
  opd_mf: "સોમવાર – શુક્રવાર", opd_sat: "શનિવાર", opd_sun: "રવિવાર", opd_closed: "બંધ",

  cd_hero_eyebrow: "દર્દી માર્ગદર્શિકા",
  cd_hero_l1: "તમારી ઈજાને સમજો.", cd_hero_l2: "રિકવરી પોતાના હાથમાં લો.",
  cd_hero_sub: "ડૉ. નાયક જે સ્થિતિઓની સારવાર કરે છે તેની સાદી ભાષાની માર્ગદર્શિકાઓ — તે શું છે, નિદાન કેવી રીતે થાય છે, અને સારવાર તથા રિકવરી ખરેખર કેવી હોય છે.",

  gd_prefix: "દર્દી માર્ગદર્શિકા", gd_of: "માંથી",
  sec_overview: "પરિચય", sec_overview_q: "આ શું છે?",
  sec_symptoms: "લક્ષણો", sec_symptoms_q: "કેવું લાગે છે?",
  sec_diagnosis: "નિદાન", sec_diagnosis_q: "તપાસ કેવી રીતે થાય છે?",
  sec_treatment: "સારવાર", sec_treatment_q: "સારવાર કેવી રીતે થાય છે?",
  sec_recovery: "રિકવરી", sec_recovery_q: "રિકવરી કેવી હોય છે?",
  gd_urgent_title: "તાત્કાલિક સંભાળ ક્યારે લેવી",
  gd_cta_eyebrow: "નિષ્ણાત સાથે વાત કરો",
  gd_cta_title: "આ લક્ષણો છે? સ્પષ્ટ યોજના મેળવો.",
  gd_cta_body: "તમારા એક્સ-રે અને રિપોર્ટ સાથે લાવો — ઘણીવાર એક જ પરામર્શ આગળનો રસ્તો નક્કી કરવા પૂરતો હોય છે.",
  gd_cta_book: "પરામર્શ બુક કરો", gd_next: "આગળની માર્ગદર્શિકા",
  gd_notfound: "માર્ગદર્શિકા મળી નથી.", gd_back: "તમામ માર્ગદર્શિકાઓ પર પાછા",
};
